/**
 * XOP Networks' own contact details — one source of truth for every surface
 * in this app that prints them (the sign-in footer, the public site footer and
 * the signed-in Contact page, `pages/portal/contact/ContactPage.tsx`).
 *
 * Mirrors `xop-edge-customer/apps/portal-web/src/lib/company.ts`, which
 * exists for the same reason: the customer portal used to inline this block
 * in its auth layout, and the second copy is how a phone number ends up
 * right on one page and stale on another. Keep the two files in step when
 * the company's details change.
 */
export const XOP_CONTACT = {
  company: "XOP Networks, Inc.",
  addressLine: "17218 Preston Road, Suite 2400, Dallas, TX 75252",
  phone: "(+1) 972-590-0200",
  support: "support@xopnetworks.com",
  sales: "sales@xopnetworks.com",
  website: "xopnetworks.com",
} as const;

/** `tel:` href for {@link XOP_CONTACT.phone} — digits and a leading `+`
 * only, because a dialler chokes on the display formatting. */
export const XOP_TEL_HREF = `tel:${XOP_CONTACT.phone.replace(/[^\d+]/g, "")}`;

/** The company slogan, as it is set on the sign-in header bar. */
export const XOP_SLOGAN = "Everything over packets";

/** Where the headquarters is on a map — OpenStreetMap's own geocode of
 * {@link XOP_CONTACT.addressLine} (Nominatim, top match, 2026-09-15). Stored,
 * not looked up per visit: Nominatim's usage policy forbids that, and the
 * address does not move. Mirrors `xop-edge-customer/apps/portal-web/src/lib/company.ts`. */
export const XOP_HQ = { lat: 32.98693, lon: -96.80353 } as const;
